<template>
  <q-page>
    
    <div class="row content">
      <div class="col-5">
        <q-datetime v-model="dateFrom" type="date" :float-label="$t('global.DateFrom')" format="D.MMM.YYYY" />
      </div>
      <div class="col-2"></div>
      <div class="col-5">
        <q-datetime v-model="dateTo" type="date" :float-label="$t('global.DateTo')" format="D.MMM.YYYY" />
      </div>
    </div>
   

    <div class="row">
      <div class="col">
        <WorkJournal v-bind:dateFrom="dateFrom" v-bind:dateTo="dateTo"></WorkJournal>
        <EventJournal v-bind:dateFrom="dateFrom" v-bind:dateTo="dateTo"></EventJournal>
        <SummaryJournal v-bind:dateFrom="dateFrom" v-bind:dateTo="dateTo"></SummaryJournal>
      </div>
    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import WorkJournal from '@/components/journal/WorkJournal.vue'
import EventJournal from '@/components/journal/EventJournal.vue'
import SummaryJournal from '@/components/journal/SummaryJournal.vue'
export default {
  name: 'Journal',
  components: {
    WorkJournal,
    EventJournal,
    SummaryJournal
  },
  data: function () {
    return {
      dateFrom: date.startOfDate(Date.now(), 'month'),
      dateTo: date.addToDate(Date.now(), { days: 0 }),
    }
  }
}
</script>
<style scoped>
.content{
  padding: 10px;
}
</style>
